import { isTypedArray as isTypedArray$1 } from '../../predicate/isTypedArray.mjs';

function isTypedArray(x) {
    return isTypedArray$1(x);
}

export { isTypedArray };
